import React, { useState } from "react"
import { graphql, useStaticQuery } from "gatsby"
import ITEMS from "./header-items.json"
import LoginIcon from "../../assets/icons/login.svg"
import CustomLink from "../custom-link/custom-link.component.jsx"
import CopiaLogo from "../../assets/icons/copia-header-logo.svg"
import { Popover, useMediaQuery, useTheme } from "@mui/material"
import MenuIcon from "../../assets/icons/menu.svg"
import CloseIcon from "@mui/icons-material/Close"

import * as S from "./header.styles.jsx"
import MenuMobile from "./menu-mobile/menu-mobile.component.jsx"

const Header = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down(1080))
  const [isActiveMenu, setIsActiveMenu] = useState(false)
  const [anchorEl, setAnchorEl] = useState(null)
  const open = Boolean(anchorEl)
  const handleClick = event => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const staticQuery = useStaticQuery(graphql`
    query {
      copiaLogo: file(relativePath: { eq: "logo.png" }) {
        childImageSharp {
          gatsbyImageData(layout: FULL_WIDTH, quality: 100)
        }
      }
    }
  `)

  const handleToggleMenu = () => {
    setIsActiveMenu(!isActiveMenu)
  }

  return (
    <>
      <S.HeaderSection id="mainNav" position="fixed" elevation={0}>
        <S.Wrapper maxWidth="xl">
          <S.ContentContainer>
            <S.LeftContainer>
              <S.ImageContainer>
                <CustomLink url="/">
                   <S.LogoImage img={staticQuery?.copiaLogo} />
                  {/*<CopiaLogo />*/}
                </CustomLink>
              </S.ImageContainer>
              {!isMobile && (
                <S.LinksContainer>
                  {ITEMS?.map(({ name, link }, index) => (
                    <S.Link url={link} key={`${name}-${index}`}>
                      {name}
                    </S.Link>
                  ))}
                </S.LinksContainer>
              )}
            </S.LeftContainer>
            <S.RightContainer>
              {!isMobile ? (
                <>
                  <S.LoginButton
                    aria-controls={open ? "menu" : undefined}
                    aria-haspopup="true"
                    aria-expanded={open ? "true" : undefined}
                    onClick={handleClick}
                  >
                    <LoginIcon />
                    Log In
                  </S.LoginButton>
                  <Popover
                    id="menu"
                    open={open}
                    anchorEl={anchorEl}
                    onClose={handleClose}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "left",
                    }}
                    PaperProps={{
                      style: {
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        borderRadius: 0,
                      },
                    }}
                  >
                    <S.MenuBox>
                      <S.Item>
                        <a href={"https://portal.gocopia.com/login"}>Donors</a>
                      </S.Item>
                      <S.Item>
                        <a href={"https://connect.gocopia.com/#/"}>
                          Nonprofits
                        </a>
                      </S.Item>
                    </S.MenuBox>
                  </Popover>
                </>
              ) : (
                <S.MenuButton onClick={handleToggleMenu} disableRipple>
                  {isActiveMenu ? <CloseIcon /> : <MenuIcon />}
                </S.MenuButton>
              )}
            </S.RightContainer>
          </S.ContentContainer>
        </S.Wrapper>
      </S.HeaderSection>
      <MenuMobile
        isActiveMenu={isActiveMenu}
        handleToggleMenu={handleToggleMenu}
      />
    </>
  )
}
export default Header
